import styled from 'styled-components';

import { CarouselSection as DefaultCarouselSection } from '@xing-com/crate-x4e-carousel-section';
import { ContentCard as DefaultContentCard } from '@xing-com/crate-x4e-content-card';
import { mediaConfined, mediaWide } from '@xing-com/layout-tokens';
import { spaceL } from '@xing-com/tokens';

export const CarouselSection = styled(DefaultCarouselSection)`
  padding: 0 ${spaceL};
  max-width: 1520px;
  width: 100%;
  margin: 0 auto;
`;

export const ContentCard = styled(DefaultContentCard)`
  min-width: 284px;
  max-width: 349px;

  @media ${mediaConfined} {
    min-width: 560px;
    max-width: 649px;
  }
  @media ${mediaWide} {
    min-width: 650px;
    max-width: 752px;
  }
`;
